import { render, staticRenderFns } from "./MemberActivityDetails.vue?vue&type=template&id=85b8eb20&scoped=true"
import script from "./MemberActivityDetails.vue?vue&type=script&lang=js"
export * from "./MemberActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberActivityDetails.vue?vue&type=style&index=0&id=85b8eb20&prod&scoped=true&lang=scss"
import style1 from "./MemberActivityDetails.vue?vue&type=style&index=1&id=85b8eb20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b8eb20",
  null
  
)

export default component.exports